import { useIsMutating } from "@tanstack/react-query";

export function useMutationStatus(mutationKey: string) {
  return useIsMutating({ mutationKey: [mutationKey] }) > 0;
}
